import type { Testimonial } from '../types/care';

export const testimonials: Testimonial[] = [
  {
    name: 'C. Tiebie',
    quote:
      'Na veel artsen bezocht te hebben kwam ik bij Excellent Care Clinics in Velsen-Noord terecht. Wat een verademing. Geen wachtlijsten, direct serieus genomen en indien mogelijk gelijk een behandeling. Er werken hele aardige en kundige mensen, erg laagdrempelig, echt geweldig.',
  },
  {
    name: 'E. de Vries',
    quote:
      'Ik was eindelijk af van die vreselijke jeuk toen ik last kreeg van zenuwpijn. Bij Excellent Care Clinics werd ik enorm goed geholpen. Mijn klachten werden serieus genomen en er is gezocht naar een goede oplossing.',
  },
  {
    name: 'M. Schemer',
    quote:
      'De medisch specialisten namen alle tijd voor mij en er werd precies uitgelegd welke behandelingen ik zou ondergaan. Ik vond het spannend, maar dat was nergens voor nodig. Nu leef ik met veel minder pijn en ik voel me super!',
  },
  {
    name: 'E. Wouterson',
    quote:
      'Binnen 2 dagen na verwijzing huisarts geholpen — wauw! Erg vriendelijk en behulpzaam personeel, er werd goed naar mij geluisterd en ik werd direct geholpen. Echt zo’n verademing vergeleken bij de ziekenhuizen!',
  },
  {
    name: 'H. Dijkstra',
    quote:
      'Wacht niet langer. Na heel veel jaar begin ik stap voor stap weer iets te leven. Fijne artsen en verpleging. Ik ben zo blij hier te zijn beland. Ik krijg stukjes leven terug. Fantastisch.',
  },
  {
    name: 'S. de la Rie',
    quote:
      'Zo kundig, vriendelijk en goed geholpen. Prachtige kliniek, mooi interieur. Zeer vriendelijk personeel. Goed advies — kortom, alleen maar positief.',
  },
  {
    name: 'L. van den Heuvel',
    quote:
      'Het eerste contact was zeer aangenaam: mijn klachten werden serieus genomen en er werd gelijk in oplossingen gedacht. Ik ben diezelfde dag behandeld met enkele injecties op de zere plekken. De klachten verminderden!',
  },
];
